module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/call_icon-74cc34046fb24e7fcb5db345500952f5.png";